import { render } from "./ProcessoVendasOrdenacaoEtapasModal.vue?vue&type=template&id=6d4b3a36&scoped=true&ts=true"
import script from "./ProcessoVendasOrdenacaoEtapasModal.vue?vue&type=script&lang=ts"
export * from "./ProcessoVendasOrdenacaoEtapasModal.vue?vue&type=script&lang=ts"

import "./ProcessoVendasOrdenacaoEtapasModal.vue?vue&type=style&index=0&id=6d4b3a36&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d4b3a36"]])

export default __exports__